var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37224 0 0 5.37224 0 12C0 18.627 5.37224 24 12 24C18.6278 24 24 18.627 24 12C24 5.37224 18.6278 0 12 0ZM17.25 12.75H9.31051L12.4012 15.8407C12.6945 16.134 12.6945 16.6087 12.4012 16.9012C12.108 17.1945 11.6333 17.1945 11.3407 16.9012L7.098 12.6585C6.91875 12.4793 6.86251 12.2325 6.90373 12C6.86247 11.7675 6.91875 11.5207 7.09875 11.3407L11.3415 7.098C11.6347 6.80475 12.1095 6.80475 12.402 7.098C12.6953 7.39125 12.6953 7.866 12.402 8.15851L9.31051 11.25H17.25C17.664 11.25 18 11.586 18 12C18 12.414 17.664 12.75 17.25 12.75Z",
    fill: "#566C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.51438cb8db888cb333fa09410b4066aa.svg";
export { ForwardRef as ReactComponent };